import { defineMessages } from 'react-intl';

export default defineMessages({
  phoneLabel: {
    defaultMessage: 'Phone Number',
    id: 'Wnk7SI',
    description: 'otherShippingOptions.phoneNumber',
  },
  phoneSublabel: {
    defaultMessage: 'Phone number is populated from the order',
    id: 't4XInX',
    description: 'phone number notification option sublabel',
  },
  emailLabel: {
    defaultMessage: 'Email Message',
    id: 'M7OVow',
    description: 'otherShippingOptions.emailAddress',
  },
  emailSublabel: {
    defaultMessage: 'Email address is populated from the order',
    id: 'ypglEi',
    description: 'email address notification option sublabel',
  },
  shipperLoadAndCountNumber: {
    defaultMessage: 'Shipper Load and Count #',
    description: 'Other shipping options shipper load and count number',
    id: 'FZRieD',
  },
  bookingLabel: {
    defaultMessage: 'Booking Confirmation #',
    description: 'Other shipping options booking confirmation number',
    id: 'UsXPnh',
  },
});
